
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace('')
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93CM3smC2FFwMeta } from "/tmp/menaceking-build-1751040864/pages/[...slug].vue?macro=true";
import { default as autologinCl76mNcPn3Meta } from "/tmp/menaceking-build-1751040864/pages/auth/autologin.vue?macro=true";
import { default as callbackiC4Jvr8QtOMeta } from "/tmp/menaceking-build-1751040864/pages/auth/social/[connection]/callback.vue?macro=true";
import { default as bettingvUqrS21DiJMeta } from "/tmp/menaceking-build-1751040864/pages/betting.vue?macro=true";
import { default as _91pageIdentity_93pggEF7599HMeta } from "/tmp/menaceking-build-1751040864/pages/bonus/[pageIdentity].vue?macro=true";
import { default as _91categoryIdentity_93xfgLjbTNm4Meta } from "/tmp/menaceking-build-1751040864/pages/categories/[categoryIdentity].vue?macro=true";
import { default as categoriesPfpTkZTjyDMeta } from "/tmp/menaceking-build-1751040864/pages/categories.vue?macro=true";
import { default as contactbq6JckXTR5Meta } from "/tmp/menaceking-build-1751040864/pages/contact.vue?macro=true";
import { default as favorites_46clientwOCkUYpRuHMeta } from "/tmp/menaceking-build-1751040864/pages/favorites.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/tmp/menaceking-build-1751040864/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as _91id_93DofnpIQb5rMeta } from "/tmp/menaceking-build-1751040864/pages/games/[id].vue?macro=true";
import { default as indexwfYirwnYi8Meta } from "/tmp/menaceking-build-1751040864/pages/index.vue?macro=true";
import { default as loyaltykef35xH4v6Meta } from "/tmp/menaceking-build-1751040864/pages/loyalty.vue?macro=true";
import { default as mainQbIqdLUctGMeta } from "/tmp/menaceking-build-1751040864/pages/main.vue?macro=true";
import { default as bonusesjaETdqvdCQMeta } from "/tmp/menaceking-build-1751040864/pages/profile/bonuses.vue?macro=true";
import { default as documentsznFLIzZbBfMeta } from "/tmp/menaceking-build-1751040864/pages/profile/documents.vue?macro=true";
import { default as historyM6QCVcHz4DMeta } from "/tmp/menaceking-build-1751040864/pages/profile/history.vue?macro=true";
import { default as infovhLK9IP7bCMeta } from "/tmp/menaceking-build-1751040864/pages/profile/info.vue?macro=true";
import { default as limitswk1IQyHXYRMeta } from "/tmp/menaceking-build-1751040864/pages/profile/limits.vue?macro=true";
import { default as notifications486Yds2xZqMeta } from "/tmp/menaceking-build-1751040864/pages/profile/notifications.vue?macro=true";
import { default as securitynn4jkCTJytMeta } from "/tmp/menaceking-build-1751040864/pages/profile/security.vue?macro=true";
import { default as verificationWNl9PWJslnMeta } from "/tmp/menaceking-build-1751040864/pages/profile/verification.vue?macro=true";
import { default as wallet8teryACKnOMeta } from "/tmp/menaceking-build-1751040864/pages/profile/wallet.vue?macro=true";
import { default as profile_46clientQME12Yc7EYMeta } from "/tmp/menaceking-build-1751040864/pages/profile.client.vue?macro=true";
import { default as providersIC9Sv0Cg61Meta } from "/tmp/menaceking-build-1751040864/pages/providers.vue?macro=true";
import { default as _91pageIdentity_93ySxfiCookaMeta } from "/tmp/menaceking-build-1751040864/pages/questions/[pageIdentity].vue?macro=true";
import { default as questionstepKYnQggbMeta } from "/tmp/menaceking-build-1751040864/pages/questions.vue?macro=true";
import { default as recently_45played_46clientF2LtmocB77Meta } from "/tmp/menaceking-build-1751040864/pages/recently-played.client.vue?macro=true";
import { default as _91pageIdentity_93erHFdknVsEMeta } from "/tmp/menaceking-build-1751040864/pages/static/[pageIdentity].vue?macro=true";
import { default as _91identity_936cqXHahcAGMeta } from "/tmp/menaceking-build-1751040864/pages/tournaments/[identity].vue?macro=true";
import { default as indexF9vKIx3MvCMeta } from "/tmp/menaceking-build-1751040864/pages/tournaments/index.vue?macro=true";
import { default as welcome_45package0yaTOrGjjQMeta } from "/tmp/menaceking-build-1751040864/pages/welcome-package.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/tmp/menaceking-build-1751040864/pages/[...slug].vue")
  },
  {
    name: "auth-autologin",
    path: "/auth/autologin",
    component: () => import("/tmp/menaceking-build-1751040864/pages/auth/autologin.vue")
  },
  {
    name: "auth-social-connection-callback",
    path: "/auth/social/:connection()/callback",
    component: () => import("/tmp/menaceking-build-1751040864/pages/auth/social/[connection]/callback.vue")
  },
  {
    name: "betting",
    path: "/betting",
    component: () => import("/tmp/menaceking-build-1751040864/pages/betting.vue")
  },
  {
    name: "bonus-pageIdentity",
    path: "/bonus/:pageIdentity()",
    component: () => import("/tmp/menaceking-build-1751040864/pages/bonus/[pageIdentity].vue")
  },
  {
    name: "categories",
    path: "/categories",
    meta: categoriesPfpTkZTjyDMeta || {},
    component: () => import("/tmp/menaceking-build-1751040864/pages/categories.vue"),
    children: [
  {
    name: "categories-categoryIdentity",
    path: ":categoryIdentity()",
    component: () => import("/tmp/menaceking-build-1751040864/pages/categories/[categoryIdentity].vue")
  }
]
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/tmp/menaceking-build-1751040864/pages/contact.vue")
  },
  {
    name: "favorites",
    path: "/favorites",
    component: () => createClientPage(() => import("/tmp/menaceking-build-1751040864/pages/favorites.client.vue"))
  },
  {
    name: "games-id",
    path: "/games/:id()",
    component: () => import("/tmp/menaceking-build-1751040864/pages/games/[id].vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/tmp/menaceking-build-1751040864/pages/index.vue")
  },
  {
    name: "loyalty",
    path: "/loyalty",
    component: () => import("/tmp/menaceking-build-1751040864/pages/loyalty.vue")
  },
  {
    name: "main",
    path: "/main",
    component: () => import("/tmp/menaceking-build-1751040864/pages/main.vue")
  },
  {
    name: "profile",
    path: "/profile",
    component: () => createClientPage(() => import("/tmp/menaceking-build-1751040864/pages/profile.client.vue")),
    children: [
  {
    name: "profile-bonuses",
    path: "bonuses",
    component: () => import("/tmp/menaceking-build-1751040864/pages/profile/bonuses.vue")
  },
  {
    name: "profile-documents",
    path: "documents",
    component: () => import("/tmp/menaceking-build-1751040864/pages/profile/documents.vue")
  },
  {
    name: "profile-history",
    path: "history",
    component: () => import("/tmp/menaceking-build-1751040864/pages/profile/history.vue")
  },
  {
    name: "profile-info",
    path: "info",
    component: () => import("/tmp/menaceking-build-1751040864/pages/profile/info.vue")
  },
  {
    name: "profile-limits",
    path: "limits",
    component: () => import("/tmp/menaceking-build-1751040864/pages/profile/limits.vue")
  },
  {
    name: "profile-notifications",
    path: "notifications",
    component: () => import("/tmp/menaceking-build-1751040864/pages/profile/notifications.vue")
  },
  {
    name: "profile-security",
    path: "security",
    component: () => import("/tmp/menaceking-build-1751040864/pages/profile/security.vue")
  },
  {
    name: "profile-verification",
    path: "verification",
    component: () => import("/tmp/menaceking-build-1751040864/pages/profile/verification.vue")
  },
  {
    name: "profile-wallet",
    path: "wallet",
    component: () => import("/tmp/menaceking-build-1751040864/pages/profile/wallet.vue")
  }
]
  },
  {
    name: "providers",
    path: "/providers",
    component: () => import("/tmp/menaceking-build-1751040864/pages/providers.vue")
  },
  {
    name: "questions",
    path: "/questions",
    meta: questionstepKYnQggbMeta || {},
    component: () => import("/tmp/menaceking-build-1751040864/pages/questions.vue"),
    children: [
  {
    name: "questions-pageIdentity",
    path: ":pageIdentity()",
    component: () => import("/tmp/menaceking-build-1751040864/pages/questions/[pageIdentity].vue")
  }
]
  },
  {
    name: "recently-played",
    path: "/recently-played",
    component: () => createClientPage(() => import("/tmp/menaceking-build-1751040864/pages/recently-played.client.vue"))
  },
  {
    name: "static-pageIdentity",
    path: "/static/:pageIdentity()",
    component: () => import("/tmp/menaceking-build-1751040864/pages/static/[pageIdentity].vue")
  },
  {
    name: "tournaments-identity",
    path: "/tournaments/:identity()",
    component: () => import("/tmp/menaceking-build-1751040864/pages/tournaments/[identity].vue")
  },
  {
    name: "tournaments",
    path: "/tournaments",
    component: () => import("/tmp/menaceking-build-1751040864/pages/tournaments/index.vue")
  },
  {
    name: "welcome-package",
    path: "/welcome-package",
    component: () => import("/tmp/menaceking-build-1751040864/pages/welcome-package.vue")
  }
]